import React, { useState, useEffect } from 'react';
import { HelpCircle, X, ChevronRight } from 'lucide-react';

const STORAGE_KEY = 'sgv-flow-guide-seen';

const STEPS = [
  { n: 1, label: 'Choose Your Goal', target: 'section-goal', detail: 'Pick a goal → the ads, offer, and numbers tune themselves to it.' },
  { n: 2, label: 'See Your Recommended Plan', target: 'section-goal', detail: 'Follow the plan → no guessing what to post where.' },
  { n: 3, label: 'Enter Your Real Numbers', target: 'section-numbers', detail: 'Type your prices once → every "$X" becomes your real offer.' },
  { n: 4, label: 'Choose or Write Your Offer', target: 'section-ai', detail: 'Give a clear offer → more people call instead of scrolling past.' },
  { n: 5, label: 'Personalize with AI', target: 'section-ai', detail: 'One click → your company, city, and phone in every asset.' },
  { n: 6, label: 'Get Your Tracking Package', target: 'section-tracking', detail: 'Deploy tracking → every call gets credited to this campaign.' },
  { n: 7, label: 'Launch', target: 'section-tracking', detail: 'Copy the assets into Google/Meta → your campaign goes live.' },
  { n: 8, label: 'Check Performance', target: 'section-kpi', detail: 'Enter your numbers weekly → see exactly what to fix or scale.' },
];

export const PageFlowGuide = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setOpen(true);
      localStorage.setItem(STORAGE_KEY, '1');
    }
  }, []);

  const jump = (target) => {
    document.getElementById(target)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        data-testid="flow-guide-open-btn"
        className="inline-flex items-center gap-1.5 text-sm text-light-gray hover:text-lime transition-colors mb-4"
      >
        <HelpCircle size={16} />
        How This Page Works
      </button>
    );
  }

  return (
    <div className="mb-6 p-5 rounded-xl bg-lime/5 border border-lime/25" data-testid="flow-guide-panel">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-white font-bold flex items-center gap-2">
          <HelpCircle size={18} className="text-lime" /> How This Page Works
        </h3>
        <button onClick={() => setOpen(false)} data-testid="flow-guide-close-btn" className="text-gray hover:text-white"><X size={18} /></button>
      </div>
      <p className="text-sm text-light-gray mb-4">Work top to bottom — click any step to jump to that section on this page.</p>
      <div className="grid md:grid-cols-2 gap-2">
        {STEPS.map((s) => (
          <button
            key={s.n}
            onClick={() => jump(s.target)}
            data-testid={`flow-guide-step-${s.n}`}
            className="flex items-start gap-3 text-left p-3 rounded-lg bg-black/40 border border-divider hover:border-lime/50 transition-colors group"
          >
            <span className="w-6 h-6 rounded-full bg-lime text-black text-xs font-black flex items-center justify-center shrink-0 mt-0.5">{s.n}</span>
            <span>
              <span className="text-sm font-bold text-white flex items-center gap-1">
                {s.label}
                <ChevronRight size={13} className="text-lime opacity-0 group-hover:opacity-100 transition-opacity" />
              </span>
              <span className="text-xs text-light-gray leading-relaxed block">{s.detail}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};
